// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function(fmt) {
    var o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    return fmt
}

export function formatTimeToStr(times, pattern) {
    var d = new Date(times).Format('yyyy-MM-dd hh:mm:ss')
    console.log(d)
    if (pattern) {
        d = new Date(times).Format(pattern)
    }
    return d.toLocaleString()
}

/**
 * 格式化日期
 * @param {string | number | Date} value 指定日期
 * @param {string} format 格式化的规则
 * @example
 * ```js
 * formatDate();
 * formatDate(1603264465956);
 * formatDate(1603264465956, "h:m:s");
 * formatDate(1603264465956, "Y年M月D日");
 * ```
 */
export function formatDate(value = Date.now(), format = 'Y-M-D h:m:s') {
    const formatNumber = n => `0${n}`.slice(-2)
    const date = new Date(value)
    const formatList = ['Y', 'M', 'D', 'h', 'm', 's']
    const resultList = []
    resultList.push(date.getFullYear().toString())
    resultList.push(formatNumber(date.getMonth() + 1))
    resultList.push(formatNumber(date.getDate()))
    resultList.push(formatNumber(date.getHours()))
    resultList.push(formatNumber(date.getMinutes()))
    resultList.push(formatNumber(date.getSeconds()))
    for (let i = 0; i < resultList.length; i++) {
        format = format.replace(formatList[i], resultList[i])
    }
    return format
}



// WEBPACK FOOTER //
// ./src/util/date.js